import { ProgressStepper } from '@lifebit-ai/lds'
import React from 'react'

import type { ExternalImportVerificationDetail } from 'services/import-requests/types'

import * as styles from './ExternalImportRequestDetailsContent.styles'
import { getExternalImportVerificationProgressStepperProps } from './getExternalImportVerificationProgressStepperProps'

export const EXTERNAL_IMPORT_EMPTY_TIMELINE_TEST_ID = 'external-import-empty-timeline'

interface ExternalImportRequestDetailsContentProps {
  importRequest: ExternalImportVerificationDetail
}

/**
 * How far an external import has got. The source it came from and the request's own metadata are
 * rendered around this by the page, so this contributes only the progress.
 */
export const ExternalImportRequestDetailsContent = ({
  importRequest
}: ExternalImportRequestDetailsContentProps): JSX.Element => {
  const progressStepperProps = getExternalImportVerificationProgressStepperProps(importRequest)

  if (progressStepperProps.steps.length === 0) {
    return (
      <styles.EmptyTimelineMessage data-testid={EXTERNAL_IMPORT_EMPTY_TIMELINE_TEST_ID}>
        Import progress is not available for this request yet.
      </styles.EmptyTimelineMessage>
    )
  }

  return <ProgressStepper {...progressStepperProps} />
}
